import { Component } from "react";
//import Select from 'react-select';

export class CustomMultiSelect extends Component {
    constructor(props) {
        super(props);
        this.state={
            selectedOptions:[]
        }
    }
    render(){
        return (
            null
        )
    }
}